import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {type SxProps} from '@mui/material/styles';
import {APP_LINKS} from '@src/config.ts';
import usePlatformAccess from '@src/hooks/usePlatformAccess.ts';

type AccountStatusAlertBannersProps = {
  sx?: SxProps;
};

const AccountStatusAlertBanners = ({sx}: AccountStatusAlertBannersProps) => {
  const platformPermissions = usePlatformAccess();

  const shouldShowExpiredAlert = platformPermissions.accountHasExpired;
  const shouldShowOutOfPUsAlert =
    !platformPermissions.accountHasExpired &&
    platformPermissions.accountOutOfPUs;

  if (!shouldShowExpiredAlert && !shouldShowOutOfPUsAlert) {
    return null;
  }

  return (
    <Box sx={sx}>
      {shouldShowExpiredAlert && (
        <Alert
          severity="warning"
          action={
            <Button
              color="inherit"
              size="small"
              href={`${APP_LINKS.account}/#/account/billing`}
            >
              Sign up
            </Button>
          }
        >
          Your account has expired, so some actions will be unavailable. Please
          visit the Account Manager or talk with your CSM to sign up for one of
          our plans.
        </Alert>
      )}
      {shouldShowOutOfPUsAlert && (
        <Alert
          severity="warning"
          action={
            platformPermissions.accountIsAdmin &&
            !platformPermissions.accountIsManaged ? (
              <Button
                color="inherit"
                size="small"
                href={`${APP_LINKS.account}/#/purchase?group=add-on`}
              >
                Top-up processing units
              </Button>
            ) : undefined
          }
        >
          You have reached your monthly processing unit limits.{' '}
          {platformPermissions.accountIsManaged
            ? 'Please contact your Planet Customer Success Manager to discuss your processing unit quota.'
            : platformPermissions.accountIsAdmin
              ? 'To continue, purchase top-up unit or upgrade to a platform plan with higher limits.'
              : 'Please contact your admin to upgrade the account or top-up processing units.'}
        </Alert>
      )}
    </Box>
  );
};

export default AccountStatusAlertBanners;
